import { useLocaleData, useT } from "../../i18n/useT";
import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

const Education = () => {
  const t = useT();
  const items = useLocaleData("sections.education.items") || [];
  const linkTooltip = useLocaleData("sections.education.linkTooltip");
  return (
    <section className="p-3 p-lg-5 d-flex flex-column" id="education">
      <h1 className="text-uppercase mb-4">{t("sections.education.title")}</h1>
      {items.map((item, idx) => (
        <div className="row my-3" key={idx}>
          <div className="col-xm-12 col-md-8">
            <h3 className="text-uppercase">
              {item.url ? (
                <a
                  href={item.url}
                  className="text-dark tooltip-element"
                  data-tooltip-content={linkTooltip}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {item.school}
                </a>
              ) : (
                item.school
              )}
            </h3>
            <h4 className="text-secondary">{item.degreeType}</h4>
            <p className="text-secondary">{item.field}</p>
          </div>
          <div className="col-xm-12 col-md-4">
            <p
              className="text-primary tooltip-element"
              data-tooltip-content={item.duration}
            >
              {item.period}
            </p>
          </div>
        </div>
      ))}
      <ReactTooltip anchorSelect=".tooltip-element" />
    </section>
  );
};

export default Education;
